import styled from "styled-components";

const Form = styled.form`
	position: relative;
	margin-bottom: 40px;
`;

export default Form;
